import React from 'react';

import { getToken } from './adal-config';

import Nav from './Components/Header'
import Videos from './Components/Videos'
import Cards from './Components/Cards'
import Horarios from './Components/Horarios'
import Instructivo from './Components/Instructivo'

export class App extends React.Component {

  state = {
    values: null,
    user: null
  }

  async componentDidMount() {

    let email = getToken()._user.userName;
    this.setState({ values: email });
  }

  render() {
    if (this.state.values) {
      return (
        <div>
        
        
          <Nav usuario={this.state.values} /><br></br>
          <center>Bienvenido, {this.state.values}</center>
          <Videos  />
          <Cards varemail={this.state.values} />
          <br/>
         
          <Horarios />   
          <Instructivo />
         
          </div>
        
      );
    }
    else {
      return (<div>Error</div>)
    }
  }
}

export default App;
